import { gql } from '@apollo/client'

export const FORGOT_CREDENTIALS = gql`
  mutation userPasswordForget(
    $name: String!,
    $email: String!,
    $message: String!
  ) {
    userPasswordForget(
      name: $name,
      email: $email,
      message: $message
    ) {
      result
    }
  }
`

export type ForgotCredentialsVariables = {
  name: string,
  email: string,
  message: string
};

export type ForgotCredentialsResult = {
  userPasswordForget: {
    result: string
  }
};
